export default __webpack_public_path__ + "static/media/shot_icon.a9857930.png";